module.exports = __webpack_public_path__ + "static/media/administration-council-bg.10b15964.jpg";